function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 14A7 7 0 107 0a7 7 0 000 14zM9.297 3.64l1.06 1.061L8.06 7l2.3 2.3-1.061 1.06-2.3-2.3-2.298 2.3L3.64 9.296 5.938 7 3.642 4.703l1.06-1.061L7 5.938l2.298-2.297z",
  fill: "#111"
});

function SvgExcludeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default SvgExcludeIcon;